import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Box, Button, Typography } from "@material-ui/core"
import { sendText } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import DialogsContainerDialog from "../../../../../../dialogs/DialogsContainer"
import LoaderButton from "../../../../../../components/LoaderButton"
import useStyles from "./styles"

const SendTextDialog = ({
  openDialog,
  toggleDialog,
  userGroups,
  userList,
  textMessageValue,
  setTextMessageValue,
  userGroupDispatch,
  setExpanded
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const organization = useSelector(state => state.organization.currentOrg)
  const [working, setWorking] = useState(false)

  const handleSendText = () => {
    let userIds = []
    Object.keys(userGroups).map(key => {
      if (userGroups[key].selected.length) {
        userIds = [...userIds, ...userGroups[key].selected]
      }
    })

    setWorking(true)
    dispatch(sendText(organization.id, userIds, textMessageValue))
      .then(() => {
        dispatch(openSnackBar({ message: "Text sent" }))
        setExpanded(false)
        setTextMessageValue("")
        userGroupDispatch({ type: "RESET_SELECTED" })
      })
      .catch(err => {
        dispatch(openSnackBar({ message: "Error sending text" }))
        console.log(err)
      })
      .finally(() => {
        setWorking(false)
        toggleDialog()
      })
  }

  return (
    <DialogsContainerDialog
      open={openDialog}
      handleClose={toggleDialog}
      title="Send Text?"
      content={
        <Box>
          <Box>
            <Typography className={classes.explanationText}>
              <span style={{ fontWeight: 700 }}>To:</span> {userList.join(", ")}
            </Typography>
          </Box>
          <Box marginTop={2}>
            <Typography className={classes.explanationText}>
              <span style={{ fontWeight: 700 }}>Message:</span>{" "}
              {textMessageValue}
            </Typography>
          </Box>
        </Box>
      }
      buttons={
        <Box>
          <Button
            variant="text"
            className={classes.cancelButton}
            onClick={toggleDialog}
          >
            cancel
          </Button>
          <LoaderButton
            onClick={handleSendText}
            working={working}
            variant="contained"
            color="primary"
          >
            Send Text
          </LoaderButton>
        </Box>
      }
      fullScreen={false}
    />
  )
}

export default SendTextDialog



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/SendTextDialog/index.jsx